import { useContext } from 'react';
import PropTypes from 'prop-types';
import TextInput from 'components/ui-components/TextInput';
import { Controller } from 'react-hook-form';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';
import provideHookFormFieldErrors from 'utils/hook-form/provideHookFormErrors';

const HookFormTextInput = ({
  className,
  variant,
  type,
  id,
  label,
  description,
  placeholder,
  value,
  rules,
}) => {
  const { control, errors, handleBlur } = useContext(HookFormContext);

  return (
    <Controller
      name={id}
      control={control}
      rules={rules}
      render={({ field }) => (
        <TextInput
          className={className}
          variant={variant}
          type={type}
          id={id}
          label={label}
          description={description}
          placeholder={placeholder}
          value={value}
          onChange={field.onChange}
          onBlur={handleBlur ? () => handleBlur(id) : undefined}
          errors={
            Object.keys(errors).length
              ? provideHookFormFieldErrors(id, errors)
              : null
          }
        />
      )}
    />
  );
};

HookFormTextInput.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  type: PropTypes.oneOf(['text', 'email', 'number', 'password', 'tel']),
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  rules: PropTypes.object,
};

export default HookFormTextInput;
